import { on } from 'delegated-events';
import Pristine from 'pristinejs';
import scrollTo from '../common/scrollTo';

const $form = document.querySelector('form.nomination-form__form');
const $nominationTypeDropdown = document.querySelector('select[name="NominationType"]');
const $individualFields = document.querySelector('.individual-fields');
const $teamFields = document.querySelector('.team-fields');
let oldFields;
let currentFields;
let oldTextAreas;
let currentTextAreas;

const SELECTORS = Selectors({
    formAnchor: '[data-form-anchor]',
    loading: 'is-loading',
    formErrorMessage: 'form-error-message'
});

export const pristineConfig = {
    classTo: 'field',
    errorClass: 'has-error',
    successClass: 'has-success',
    errorTextParent: 'field',
    errorTextTag: 'div',
    errorTextClass: 'text-help',
};

const fn = {
    init: () => {
        fn.setActive($individualFields, $teamFields);
        on('change', 'select[name="NominationType"]', () => {
            let currentValue = $nominationTypeDropdown.options[$nominationTypeDropdown.selectedIndex].value;
            switch (currentValue) {
                case 'Individual':
                    fn.setActive($individualFields, $teamFields);
                    break;
                case 'Team':
                    fn.setActive($teamFields, $individualFields);
                    break;
                case '':
                    $($individualFields).removeClass('active');
                    $($teamFields).addClass('active');
                    break;
                default:
                    break;
            }
            return false;
        });

        $form.addEventListener('submit', e => {

            const pristine = new Pristine($form, pristineConfig)
            const valid = pristine.validate()

            e.preventDefault()
            if (!valid) {
                e.preventDefault();
                const $firstError = $form.querySelector('.field.has-error');

                if ($firstError) {
                    if ($firstError.classList.contains('textarea')) {
                        scrollTo($firstError, 150, () => $firstError.querySelector('textarea').focus());
                    }
                    else {
                        scrollTo($firstError, 150, () => $firstError.querySelector('input').focus());
                    }
                }

                return false;
            }
            else {

                const $submitButton = $form.querySelector('[type=submit]');
                $submitButton.disabled = true;
                $submitButton.classList.add(SELECTORS.loading);

                const formData = new FormData($form);

                const $errorMessage = $form.querySelector(SELECTORS.asClass('formErrorMessage'));
                $errorMessage.style.display = 'none';

                $.ajax({
                    type: 'post',
                    url: $form.action,
                    data: formData,
                    dataType: 'json',
                    processData: false,
                    contentType: false,
                    success: resp => {
                        if (resp.success) {
                            $form.innerHTML = `<div class="form-success-message">${resp.message}</div>`;

                            // Figure out where to scroll to
                            let $anchor = $form.closest(SELECTORS.formAnchor);
                            $anchor =
                                $anchor ? $anchor :
                                $form;

                            scrollTo($anchor, 150);

                        } else {

                            $errorMessage.innerHTML = resp.message;
                            $errorMessage.style.display = 'block';

                            if (resp.field_errors) {
                                for (const field of resp.field_errors) {
                                    const $field = $form.querySelector(`[name="${field}"]`);

                                    if ($field) {
                                        $field.classList.add('has-field-error');
                                    }
                                }
                            }
                        }
                    },
                    error: () => {
                        $errorMessage.innerHTML = 'Sorry, there was a problem with your submission';
                        $errorMessage.style.display = 'block';
                    },
                    complete: () => {
                        $submitButton.disabled = false;
                        $submitButton.classList.remove(SELECTORS.loading);
                    },
                });

            }
        });

    },

    setActive: (active, inactive) => {
        $(inactive).removeClass('active');
        oldFields = inactive.querySelectorAll('input');
        oldFields.forEach(field => {
            field.removeAttribute('required');
            field.removeAttribute('aria-required');
            field.removeAttribute('data-pristine-required');
        });
        oldTextAreas = inactive.querySelectorAll('textarea');
        oldTextAreas.forEach(textArea => {
            textArea.removeAttribute('required');
            textArea.removeAttribute('aria-required');
            textArea.removeAttribute('data-pristine-required');
        });
        $(active).addClass('active');
        currentFields = active.querySelectorAll('input');
        currentFields.forEach(field => {
            field.setAttribute('required', 'required');
            field.setAttribute('aria-required', 'true');
            field.setAttribute('data-pristine-required', 'true');
        });
        currentTextAreas = active.querySelectorAll('textarea');
        currentTextAreas.forEach(TextArea => {
            TextArea.setAttribute('required', 'required');
            TextArea.setAttribute('aria-required', 'true');
            TextArea.setAttribute('data-pristine-required', 'true');
        });
    },
};

export default {
    can: () => $form,
    run: fn.init,
};
